import type { FaireAdvertiserProfileEntity } from "../../entity_types/advertiserProfile";

// EU Brand (b_5qsm2e4kdh, advertiser 8420071495843407397). EUR advertiser.
// Lifetime complete-month metrics Jun–Sep 2026 from ANALYTICS.ADS.CAMPAIGN_PERIODS.
// Monthly series + partial Oct 2026 live in realBrandData.ts.
//
// Short tenure (campaigns from Jun 9 2026). Pooled at €150 through Jul 13, then
// NON_POOLED (€300 new / €100 reorder, new raised to €400 on Oct 1). Reorder
// campaign stopped Oct 1 2026. Spending mode MAXIMUM.
export const advEuBrand: FaireAdvertiserProfileEntity = {
  token: "adv_eu_brand",
  type: "advertiserProfile",
  archetype: "new-and-returning",
  displayName: "EU Brand",
  brandToken: "b_5qsm2e4kdh",
  audienceType: "NEW_AND_RETURNING",
  globalStatus: "ACTIVE",
  tenureMonths: 5,
  budget: {
    totalBudgetDollars: 400,
    spendingMode: "MAXIMUM",
    nextRenewsAtDate: "2026-11-01",
    nextBillsAtDate: "2026-11-04",
  },
  overview: {
    numCustomersAcquired: 12,
    numReorderConversions: 10,
    numTotalConversions: 22,
    totalAdsSalesDollars: 4008,
    newCustomerAdsSalesDollars: 1640,
    reorderAdsSalesDollars: 2368,
    totalAdsSpendDollars: 759,
    newCustomerAdsSpendDollars: 635,
    reorderAdsSpendDollars: 123,
    newCustomerBestEstimateFirstYearRoas: 3.89,
    reorderRoas: 19.23,
    combinedFirstYearRoas: 6.38,
    numNewCustomerAdsOrders: 13,
    numReorderAdsOrders: 10,
  },
  availableCredit: { totalRemainingDollars: 0 },
  budgetRecommendations: {
    newCustomer: {
      minRecommendedBudgetDollars: 300,
      maxRecommendedBudgetDollars: 600,
      isEligibleForIncreaseRec: false,
    },
    reorder: {
      minRecommendedBudgetDollars: 80,
      maxRecommendedBudgetDollars: 160,
      isEligibleForIncreaseRec: false,
    },
  },
  campaignTokens: ["camp_eu_new", "camp_eu_reorder"],
  overviewPerformancePeriodTokens: [],
  meta: {
    source: "snowflake",
    importedAt: "2026-10-12T00:00:00.000Z",
    importedBy: "real-brand-data",
  },
};
